import React, { Component } from 'react'
import CookieConsent from "react-cookie-consent";
import { Link } from 'react-router-dom';

export default class CookieConsentComponent extends Component {
    render() {
        return (
            <>
                <CookieConsent
                    location="bottom"
                    buttonText="Aceitar"
                    cookieName="bannerCookie"
                    style={{ background: "var(--color-white)", color: 'var(--color-black)' }}
                    buttonStyle={{ 
                        color: "var(--color-white)", 
                        fontSize: "14px", 
                        background: "var(--color-primary)", 
                        padding: '8px 40px', 
                        borderRadius: '50px' 
                    }}
                    expires={150}
                >
                    Usamos cookies em nosso site para fornecer a experiência mais relevante. Ao clicar em "Aceitar", você concorda com o uso de TODOS os cookies. <br />
                    Acesse nossa <a href="https://up365capital.com.br/politica.html" className="tx-pink fw-bold" target="_blank">Política de Privacidade</a>.
                </CookieConsent>
            </>
        )
    }
}